import React, { Component } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  Button,
  Breadcrumbs,
  Link,
  Chip,
  Checkbox,
} from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import CachedIcon from "@mui/icons-material/Cached";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CtDtp from "./CustomTool/CtDtp";
import {
  get_30DaysBack_FromCurrentDate,
  get_YMD_from_SYS,
} from "../SystemUtility/SystemUtility";

const columns = [
  {
    key: "potential",
    title: "Renewal Potential",
    total: 40,
    color: "#26c6da",
    soft: "#e0f7fa",
    items: [
      {
        label: "Bhavnagar",
        count: 5,
        details: [
          "Lift 1   01/01/2025 to 31/12/2025",
          "Lift 2   31/01/2025 to 01/02/2026",
          "Lift 3   01/01/2025 to 31/03/2026",
          "Lift 4   01/02/2025 to 31/01/2026",
          "Lift 5   31/01/2025 to 01/02/2026",
        ],
      },
      { label: "Rajkot", count: 10 },
      { label: "Surat", count: 10 },
      { label: "Baroda", count: 15 },
    ],
  },
  {
    key: "submitted",
    title: "Renewal Submitted",
    total: 30,
    color: "#1e88e5",
    soft: "#e3f2fd",
    items: [
      { label: "Bhavnagar", count: 5 },
      { label: "Rajkot", count: 10 },
      { label: "Surat", count: 5 },
      { label: "Baroda", count: 5 },
      { label: "Morbi", count: 5 },
    ],
  },
  {
    key: "done",
    title: "Renewal Done",
    total: 20,
    color: "#66bb6a",
    soft: "#e8f5e9",
    items: [
      { label: "Bhavnagar", count: 5 },
      { label: "Rajkot", count: 10 },
      { label: "Surat", count: 5 },
    ],
  },
  {
    key: "lost",
    title: "Renewal Lost",
    total: 10,
    color: "#ef5350",
    soft: "#ffebee",
    items: [
      { label: "Bhavnagar", count: 5 },
      { label: "Rajkot", count: 5 },
    ],
  },
];

class AMCKanbanView extends Component {
  state = {
    formData: {
      dtpfromdate: get_30DaysBack_FromCurrentDate(new Date()),
      dtptodate: get_YMD_from_SYS(new Date()),
    },
    expanded: {},
    selected: {},
  };

  handleOnChange = (e) => {
    const { id, value } = e.target;
    this.setState({
      formData: {
        ...this.state.formData,
        [id]: value,
      },
    });
  };

  handleLoad = () => {
    const { dtpfromdate, dtptodate } = this.state.formData;
    console.log("LOAD KANBAN DATA", dtpfromdate, dtptodate);
    // API call here
  };

  toggleExpand = (key) => {
    this.setState((prev) => ({
      expanded: {
        ...prev.expanded,
        [key]: !prev.expanded[key],
      },
    }));
  };

  toggleSelect = (key) => {
    this.setState((prev) => ({
      selected: {
        ...prev.selected,
        [key]: !prev.selected[key],
      },
    }));
  };

  renderItem = (item, index, soft, colKey) => {
    const rowKey = `${colKey}-${item.label}-${index}`;
    const isOpen = !!this.state.expanded[rowKey];
    const isSelected = !!this.state.selected[rowKey];
    const details =
      item.details?.length && item.details.length
        ? item.details
        : [
            "Lift 1   01/01/2025 to 31/12/2025",
            "Lift 2   31/01/2025 to 01/02/2026",
            "Lift 3   01/01/2025 to 31/03/2026",
          ];

    return (
      <Box
        key={`${item.label}-${index}`}
        sx={{
          background: soft,
          borderRadius: 2,
          p: 1,
          mb: 1,
          boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <KeyboardArrowDownIcon
              sx={{
                color: "#6b6b6b",
                transform: isOpen ? "rotate(0deg)" : "rotate(-90deg)",
                transition: "transform 0.2s ease",
                cursor: "pointer",
              }}
              onClick={() => this.toggleExpand(rowKey)}
            />
            <Checkbox
              size="small"
              checked={isSelected}
              onChange={() => this.toggleSelect(rowKey)}
              sx={{ p: 0.5 }}
            />
            <Typography fontWeight={600} fontSize={13}>
              {item.label}
            </Typography>
          </Box>
          <Chip
            label={item.count}
            size="small"
            sx={{
              height: 22,
              fontSize: 12,
              fontWeight: 700,
              background: "#fff",
              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
            }}
          />
        </Box>

        {isOpen ? (
          <Box
            sx={{
              mt: 1,
              background: "#fff",
              borderRadius: 1,
              p: 1,
              fontSize: 12,
              color: "#4b4b4b",
              lineHeight: 1.5,
              boxShadow: "inset 0 0 0 1px #e0e0e0",
            }}
          >
            {details.map((line) => (
              <Typography key={line} fontSize={12}>
                {line}
              </Typography>
            ))}
          </Box>
        ) : null}
      </Box>
    );
  };

  render() {
    return (
      <Card sx={{ p: 2, borderRadius: 3 }}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/#/Dashboard">
              Dashboard
            </Link>
            <Link underline="hover" color="inherit" href="/#/AMCDashboard">
              AMC Dashboard
            </Link>
          <Typography sx={{ color: "text.primary" }}>AMC Renewal Kanban View</Typography>
        </Breadcrumbs>

        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <Grid container spacing={2} alignItems="flex-end" sx={{ width: "auto" }}>
            <Grid item>
              <CtDtp
                id="dtpfromdate"
                value={this.state.formData.dtpfromdate}
                label="From Date*"
                handleOnChange={this.handleOnChange}
                width={150}
              />
            </Grid>

            <Grid item>
              <CtDtp
                id="dtptodate"
                value={this.state.formData.dtptodate}
                label="To Date*"
                handleOnChange={this.handleOnChange}
                width={150}
              />
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                startIcon={<CachedIcon />}
                sx={{ height: 40, borderRadius: 2 }}
                onClick={this.handleLoad}
              >
                LOAD
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Grid container spacing={2}>
          {columns.map((col) => (
            <Grid item xs={12} sm={6} md={3} key={col.key}>
              <Card sx={{ p: 1.5, borderRadius: 2, boxShadow: 4 }}>
                <Box
                  sx={{
                    background: col.color,
                    color: "#fff",
                    borderRadius: 1,
                    px: 1.5,
                    py: 0.8,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography fontSize={12} fontWeight={600}>
                    {col.title}
                  </Typography>
                  <Typography fontSize={22} fontWeight={800}>
                    {col.total}
                  </Typography>
                </Box>

                {col.items.map((item, index) =>
                  this.renderItem(item, index, col.soft, col.key),
                )}
              </Card>
            </Grid>
          ))}
        </Grid>
      </Card>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCKanbanView {...props} navigate={navigate} />;
}

export default WithNavigate;
